import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';


export default function CampaignInfo(){
  const { campaignObj} = useSelector((state)=>state.manufslice.campaignDashboard);
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'white'}}
      >
            
        <Grid item lg={4} xs={6}><FieldView2 label="Business Id"  value={ campaignObj.businessid!==null && campaignObj.businessid!==undefined?campaignObj.businessid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="title"  value={ campaignObj.title!==null && campaignObj.title!==undefined?campaignObj.title:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Audience Id"  value={ campaignObj.audienceid!==null && campaignObj.audienceid!==undefined?campaignObj.audienceid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Audience Name"  value={ campaignObj.audiencename!==null && campaignObj.audiencename!==undefined?campaignObj.audiencename:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Audience Email"  value={ campaignObj.audienceemail!==null && campaignObj.audienceemail!==undefined?campaignObj.audienceemail:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Template  Id"  value={ campaignObj.templateid!==null && campaignObj.templateid!==undefined?campaignObj.templateid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Template  Name"  value={ campaignObj.templatename!==null && campaignObj.templatename!==undefined?campaignObj.templatename:'NOT KNONWN' }/></Grid>
      </Grid>
      </Grid>
      </Box>
    )
}